import { Slide } from "react-reveal";
import Footer from "../footer/Footer";

const HomeHero = () => {
  return (
    <section className="hero relative world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container hero-content-container">
            <div className="construction padding-8">
              <p className="ict-dark center capitalize slide-in-down">
                <img
                  src="https://res.cloudinary.com/malidad/image/upload/v1778292321/rocket-launch-icon_ikppuz.svg"
                  alt="Launch"
                />
                <span>Opening soon!</span>
              </p>
            </div>
            <div className="centered brand">
              <div className="centered-inner">
                <Slide top>
                  <img
                    src="https://res.cloudinary.com/malidad/image/upload/v1778658274/ict_full_brand-200_zthsse.webp"
                    className="ict-brand"
                    alt="Uganda School of ICT"
                  />
                </Slide>
                <ul className="launch-cards-container flex">
                  <Slide top>
                    <li className="launch-card">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292321/online-learning-icon_ygt1ru.svg"
                        alt="Online Learning"
                      />
                      <h1 className="ict-text-fill">
                        Education, Packaged for Real-life
                      </h1>
                      <p>
                        Structured ICT & AI learning packages designed for
                        real-world success
                      </p>
                    </li>
                  </Slide>
                  <Slide top>
                    <li className="launch-card">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292321/working-on-laptop-icon_wssmp6.svg"
                        alt="Skill"
                      />
                      <h1 className="ict-text-fill">
                        Practical, High-value Tech Skills
                      </h1>
                      <p>
                        In-demand tech skills for immediate income generation
                        and career growth
                      </p>
                    </li>
                  </Slide>
                  <Slide bottom>
                    <li className="launch-card">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292321/rich-icon_nfrzck.svg"
                        alt="Earn Income"
                      />
                      <h1 className="ict-text-fill">
                        Education That Pays Off Fast
                      </h1>
                      <p>
                        ICT & AI skills that make you serious money from your
                        investment in education
                      </p>
                    </li>
                  </Slide>
                  <Slide bottom>
                    <li className="launch-card">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292320/experience-expert-icon_lo2iuy.svg"
                        alt="Expert"
                      />
                      <h1 className="ict-text-fill">
                        Learn from Real-world Practitioners
                      </h1>
                      <p>
                        Taught by active professionals, entrepreneurs & builders
                        in tech
                      </p>
                    </li>
                  </Slide>
                </ul>
                <div className="launch-cta-container">
                  <img
                    src="https://res.cloudinary.com/malidad/image/upload/v1778292321/school-building-icon_y0r5rz.svg"
                    alt="School Icon"
                  />
                  <h2 className="ict-text-fill">
                    Be among the first to join Uganda School of ICT
                  </h2>
                  <p>Limited slots available for our first intake.</p>
                  <Slide top>
                    <a
                      href="https://form.jotform.com/ugandaschoolofict/reserve-your-place"
                      target="_blank"
                      className="button launch-cta boldTitle"
                      rel="noopener noreferrer"
                    >
                      Reserve your place now &rarr;
                    </a>
                  </Slide>
                </div>
                <ul className="contacts section-spacing-10">
                  <li>
                    <a href="tel:+256756363333" title="+256-756-363-333">
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292323/call-square-icon_hfujy1.svg"
                        alt="Call Us Now"
                      />
                      <p>+256-756-363-333</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://facebook.com/ICTSchoolUganda"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="ICTSchoolUganda"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777962168/facebook-square-icon_a32wly.svg"
                        alt="Facebook"
                      />
                      <p>ICTSchoolUganda</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/ICTSchoolUganda"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="ICTSchoolUganda"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777962174/x-social-media-logo-icon_cvr5sq.svg"
                        alt="Twitter"
                      />
                      <p>ICTSchoolUganda</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://linkedin.com/company/ICTSchoolUganda"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="ICTSchoolUganda"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777962177/linkedin-app-icon_urola3.svg"
                        alt="Linkedin"
                      />
                      <p>ICTSchoolUganda</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com/ICTSchoolUganda"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="ICTSchoolUganda"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1777962169/insta_rollxq.svg"
                        alt="Instagram"
                      />
                      <p>ICTSchoolUganda</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://tiktok.com/ICTSchoolUganda"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="ICTSchoolUganda"
                    >
                      <img
                        src="https://res.cloudinary.com/malidad/image/upload/v1778292324/tiktok-rounded-square-icon_fldmal.svg"
                        alt="Tiktok"
                      />
                      <p>ICTSchoolUganda</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default HomeHero;
